"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.MenuPanelRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _subNavMenu = _interopRequireDefault(require("./sub-nav-menu"));
var _productMenu = _interopRequireDefault(require("./product-menu"));
var _basicMenu = _interopRequireDefault(require("./basic-menu"));
// import TwoRowsCard from './two-rows-card';
// import BackgroundImageWithText from './background-image-with-text-card';

var menuTypeComponents = {
  product: _productMenu["default"],
  subNav: _subNavMenu["default"],
  basic: _basicMenu["default"]
};
var MenuPanelRenderer = function MenuPanelRenderer(_ref) {
  var index = _ref.index,
    noDropDown = _ref.noDropDown,
    hideArrows = _ref.hideArrows,
    keyHandler = _ref.keyHandler,
    keyHandlerMethod = _ref.keyHandlerMethod,
    clickHandler = _ref.clickHandler,
    activeNav = _ref.activeNav,
    menuOpen = _ref.menuOpen,
    isLast = _ref.isLast,
    theme = _ref.theme,
    name = _ref.name,
    products = _ref.products,
    vehicleCardsCTAs = _ref.vehicleCardsCTAs,
    links = _ref.links,
    subNavigationcontainer = _ref.subNavigationcontainer,
    posInSet = _ref.posInSet,
    setSize = _ref.setSize,
    backgroundImage = _ref.backgroundImage,
    config = _ref.config,
    focusHandler = _ref.focusHandler,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    currentPath = _ref.currentPath,
    displayNavInTwoColumns = _ref.displayNavInTwoColumns,
    market = _ref.market,
    mobileNavActive = _ref.mobileNavActive,
    shoppingToolsCTAs = _ref.shoppingToolsCTAs,
    imageWithText = _ref.imageWithText;
  var menuType;
  if (noDropDown === 'true') {
    menuType = 'basic';
  } else if (subNavigationcontainer.subNavigationItems.length) {
    menuType = 'subNav';
  } else if (products && products.length) {
    menuType = 'product';
  } else {
    menuType = 'basic';
  }
  var CardComponent = menuTypeComponents[menuType];
  return /*#__PURE__*/_react["default"].createElement(CardComponent, {
    keyHandler: keyHandler,
    keyHandlerMethod: keyHandlerMethod,
    clickHandler: clickHandler,
    activeNav: activeNav,
    menuOpen: menuOpen,
    isLast: isLast,
    theme: theme,
    name: name,
    products: products,
    vehicleCardsCTAs: vehicleCardsCTAs,
    links: links,
    subNavigationcontainer: subNavigationcontainer,
    shoppingToolsCTAs: shoppingToolsCTAs,
    posInSet: posInSet,
    setSize: setSize,
    backgroundImage: backgroundImage,
    config: config,
    focusHandler: focusHandler,
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData,
    currentPath: currentPath,
    displayNavInTwoColumns: displayNavInTwoColumns,
    imageWithText: imageWithText,
    market: market,
    mobileNavActive: mobileNavActive,
    hideArrows: hideArrows
  });
};
exports.MenuPanelRenderer = MenuPanelRenderer;